import { map, pick } from 'lodash-es'

const transformToUserInput = data => {
  const userInput = pick(data, ['name', 'email', 'isActive'])

  return {
    ...userInput,
    roleIds: map(data.roleIds, Number),
  }
}

export default transformToUserInput
